import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Layout from "../Layout";
import HeaderOrg from "../organizations/HeaderOrg";
import useUserStore from "../../utils/storeApp";

const UploadResults = () => {
  const navigate = useNavigate();
  const { sharedObject } = useUserStore((state) => ({
    sharedObject: state.sharedObject,
  }));
  const [failedNr, SetFailedNr] = useState([]);
  const [successNr, SetSuccessNr] = useState([]);
  const [validationNr, SetValidationNr] = useState([]);
  const [obj, SetObj] = useState([]);
  useEffect(() => {
    console.log(sharedObject);
    if (sharedObject.UploadObj.length > 0) {
      BuildUploadObj(sharedObject.UploadObj);
    }
  }, [sharedObject.UploadObj]);
  const BuildUploadObj = async (obj) => {
    let failedHolder = [];
    let successHolder = [];
    let validationHolder = [];
    obj.map((el) => {
      el.Status === "Success"
        ? successHolder.push(el)
        : el.Status === "FailedValidation"
        ? validationHolder.push(el)
        : failedHolder.push(el);
    });
    SetFailedNr(failedHolder);
    SetSuccessNr(successHolder);
    SetValidationNr(validationHolder);
    SetObj(obj);
  };

  const buildHtml = (el) => {
    /*return sharedObject.UploadFlag === "org"
          ? `<span>${el.OrganizationName} </span><span>${el.Address1} ${el.City} ${el.State} ${el.Zipcode} </span><span> ${el.PhoneNumber} </span>`
          : sharedObject.UploadFlag === "orgEmail"
          ? `<span>${el.RequestedOrgDirectEmail} </span><span>${el.EmailPurpose}`
          : `<span>${el.FirstName} </span><span>${el.LastName} <span>${el.ContactEmail} </span>`;*/

    return `<span>${el.ValidationMessage} </span>`;
  };
  const buildHtmlFailed = (el) => {
    return sharedObject.UploadFlag === "org"
      ? `<span>${el.OrganizationName} </span><span>${el.Address1} ${el.City} ${el.State} ${el.Zipcode} </span><span> ${el.PhoneNumber} </span>`
      : sharedObject.UploadFlag === "orgEmail"
      ? `<span>${el.RequestedOrgDirectEmail} </span><span>${el.EmailPurpose}`
      : `<span>${el.FirstName} </span><span>${el.LastName} <span>${el.ContactEmail} </span>`;
  };
  return (
    <Layout>
      <HeaderOrg />
      <section className="layout-container">
        <div className="container sp-pad1">
          {failedNr.length > 0 || validationNr.length > 0 ? (
            <div className="alert-error">
              <i
                className="bi bi-exclamation-diamond"
                alt="Needs Attention"
              ></i>
            </div>
          ) : (
            <div className="bi-success-check field-wrapper">
              <i className="bi bi-check2-circle" alt="Success Checkmark"></i>
              <h2 className="g-clr">
                All accounts have been successfully registered!
              </h2>
            </div>
          )}
          {/* -------------- End ---------------------------*/}
          <div className="field-wrapper">
            <label>Accounts requested:</label> {obj.length} <br />
            <label>Accounts successfully registered:</label> {successNr.length}{" "}
            <br />
            <label>Accounts failed to register: </label> {failedNr.length}{" "}
            <br />
            <label>Accounts failed validation: </label> {validationNr.length}{" "}
            <br />
          </div>

          {/*Hide this if upload is successful*/}
          <hr />
          {failedNr.length > 0 ? (
            <div className="text-size6 spacer-margin3">
              Failed Message{" "}
              <div className="sub-box1 field-wrapper">
                {failedNr.map((elx) => {
                  return (
                    <div
                      dangerouslySetInnerHTML={{ __html: buildHtmlFailed(elx) }}
                    />
                  );
                })}
              </div>
              <div className="field-wrapper">
                Failed Message{" "}
                <span className="or-clr">
                  Avoid uploading the entire file again to prevent duplicate
                  accounts.
                </span>
              </div>
            </div>
          ) : null}
          {validationNr.length > 0 ? (
            <div className="text-size6 spacer-margin3">
              The following account(s) could not be registered due to incorrect
              formatting:
              <div className="sub-box1 field-wrapper">
                {validationNr.map((el) => {
                  return (
                    <div dangerouslySetInnerHTML={{ __html: buildHtml(el) }} />
                  );
                })}
              </div>
              <div className="field-wrapper">
                Please correct any errors in those accounts and upload a new
                file only with the corrected information.{" "}
                <span className="or-clr">
                  Avoid uploading the entire file again to prevent duplicate
                  accounts.
                </span>
              </div>
            </div>
          ) : null}
          {/* -------------- End ---------------------------*/}
          <div className="field-wrapper spacer-margin4 ctr">
            Contact support if you need assistance at 1-888-470-9913 or email{" "}
            <a href="mailto: support@secureexsolutions.com">
              support@secureexsolutions.com
            </a>
          </div>
          <hr />
          <button onClick={() => navigate(-1)} className="btn btn-primary">
            Go back
          </button>
        </div>
      </section>
    </Layout>
  );
};

export default UploadResults;
